import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

import axios from 'axios'

export default new Vuex.Store({
    state: {
        signup_type: null,
        token: null,
        user: null,
        // tokenId: null
    },
    mutations: {
        storeSignupType(state, signup_type) {
            state.signup_type = signup_type;
        },
        clearSignupType(state) {
            state.signup_type = null;
        },
        storeToken(state, token) {
            state.token = token;
            var authHeader = 'Bearer ' + state.token;
            axios.defaults.headers.common['Authorization'] = authHeader;
        },
        clearToken(state) {
            state.token = null;
            delete axios.defaults.headers.common['Authorization'];
        },
        storeUser(state, user) {
            state.user = user
        },
        clearUser(state) {
            state.user = null
        },
        // clearTokenId (state) {
        //     state.tokenId = null
        // }
    },
    actions: {
        storeSignupType(context, data) {
            context.commit('storeSignupType', data)
                // context.commit('storeTokenId', data.token_id)
        },
        clearSignupType(context) {
            context.commit('clearSignupType')
                // context.commit('clearTokenId')
        },
        storeToken(context, data) {
            context.commit('storeToken', data)
                // context.commit('storeTokenId', data.token_id)
        },
        clearToken(context) {
            context.commit('clearToken')
                // context.commit('clearTokenId')
        },
        storeUser(context, data) {
            context.commit('storeUser', data)
                // context.commit('storeTokenId', data.token_id)
        },
        clearUser(context) {
            context.commit('clearUser')
                // context.commit('storeTokenId', data.token_id)
        }
    },
    plugins: [createPersistedState()]
})